import styled from 'styled-components'

export const FormRow = styled.div`
  margin: 0 0 1.6rem;
  
  &.boxed {
    border: 1px solid white;
    padding: 1rem;
  };
`